import { IQueryContext } from 'framework/context/IQueryContext';
import { IExactOnlineProductCatalogItemDto, IExactOnlineProductCatalogItemsQueryParams, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const ExactOnlineProductCatalogItemsQueryContext = React.createContext<
	IQueryContext<IQueryResult<IExactOnlineProductCatalogItemDto>, IExactOnlineProductCatalogItemsQueryParams>
>(undefined as any);
